<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100">
    <form
      @submit.prevent="handleSubmit"
      class="bg-white p-6 rounded shadow-md w-full max-w-lg"
    >
      <h2 class="text-2xl font-bold mb-6">
        {{ title || "How do you rate your overall experience?" }}
      </h2>

      <div class="mb-4">
        <StarRatingPicker v-model="form.rating"></StarRatingPicker>
        <span
          v-if="!$v.form.rating.required && $v.form.rating.$error"
          class="text-red-500 text-sm"
          >Rating is required</span
        >
      </div>

      <div class="mb-4">
        <label for="comments" class="block text-gray-700 font-bold mb-2">{{
          commentLabel || "Comments"
        }}</label>
        <textarea
          v-model="form.comments"
          id="comments"
          rows="4"
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        ></textarea>
        <span
          v-if="!$v.form.comments.required && $v.form.comments.$error"
          class="text-red-500 text-sm"
          >Comments are required</span
        >
      </div>

      <div class="mb-4">
        <label for="name" class="block text-gray-700 font-bold mb-2">{{
          nameLabel || "Name"
        }}</label>
        <input
          v-model="form.name"
          id="name"
          type="text"
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        />
        <span
          v-if="!$v.form.name.required && $v.form.name.$error"
          class="text-red-500 text-sm"
          >Name is required</span
        >
      </div>

      <div class="mb-6">
        <label for="email" class="block text-gray-700 font-bold mb-2">{{
          emailLabel || "Email ID"
        }}</label>
        <input
          v-model="form.email"
          id="email"
          type="email"
          class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
        />
        <span
          v-if="!$v.form.email.required && $v.form.email.$error"
          class="text-red-500 text-sm"
          >Email is required</span
        >
        <span
          v-if="!$v.form.email.email && $v.form.email.$error"
          class="text-red-500 text-sm"
          >Email must be valid</span
        >
      </div>

      <div class="flex items-center justify-between">
        <button
          type="submit"
          class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
        >
          {{ submitButtonLabel || "Submit" }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";

import StarRatingPicker from "../components/Reviews/StarRatingPicker.vue";

export default {
  components: {
    StarRatingPicker
  },
  data() {
    return {
      form: {
        rating: 0,
        comments: "",
        name: "",
        email: ""
      },
      storeId: "",
      title: "",
      commentLabel: "",
      nameLabel: "",
      emailLabel: "",
      submitButtonLabel: ""
    };
  },
  validations: {
    form: {
      rating: { required },
      comments: { required },
      name: { required },
      email: { required, email }
    }
  },
  created() {
    this.storeId = this.$route.params.storeId;
    this.$store
      .dispatch("getPublicReviewRequestForm", { storeId: this.storeId })
      .then(response => {
        if (response.feedbackFormLabels) {
          this.title = response.feedbackFormLabels.title;
          this.commentLabel = response.feedbackFormLabels.commentLabel;
          this.nameLabel = response.feedbackFormLabels.nameLabel;
          this.emailLabel = response.feedbackFormLabels.emailLabel;
          this.submitButtonLabel = response.feedbackFormLabels.submitButton;
        }
      });
  },
  methods: {
    handleSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      // Handle form submission
      console.log(this.form);
      this.$store
        .dispatch("submitFeedback", {
          requestParams: this.form,
          storeId: this.storeId
        })
        .then(() => {
          alert("Thank you! Your feedback is sent to the store");
          this.form = { rating: 0, comments: "", name: "", email: "" };
        });
    }
  }
};
</script>

<style></style>
